export { default } from "./useRestMutation";
